// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"6217c053","513":"b4138830","703":"046cf882","787":"c1112931"}[chunkId] + ".chunk.js";
};